export const dosmuratov = {
    id: "dosmuratov",
    name: { ru: "Досмуратов Маханбет Манасович", kz: "Досмуратов Маханбет Манасұлы" },
    position: { 
      ru: "Руководитель ГККП «Спортивный медицинский центр города Астаны»", 
      kz: "ГККП «Астана қаласының Спорттық медициналық орталығы» басшысы" 
    },
    department: "management",
    image: "/team_photoes/new/dosmuratov.jpeg",
    experience: {
      ru: "С 2013 года",
      kz: "2013 жылдан бері"
    },
    education: {
      ru: `• 2006–2013 гг. — АО «Медицинский университет Астана», факультет «Лечебное дело», квалификация врач-хирург
• 12.08.2013–30.12.2013 гг. — АО «Медицинский университет Астана», переподготовка по специальности «Оториноларингология»
• 25.02.2019–26.06.2019 гг. — Казахстанский медицинский университет «Высшая школа общественного здравоохранения», г. Нур-Султан, менеджмент здравоохранения`,
      kz: `• 2006–2013 жж. — «Астана медицина университеті» АҚ, «Емдеу ісі» факультеті, біліктілігі дәрігер-хирург
• 12.08.2013–30.12.2013 жж. — «Астана медицина университеті» АҚ, «Оториноларингология» мамандығы бойынша қайта даярлау
• 25.02.2019–26.06.2019 жж. — Қазақстандық медициналық университеті «Қоғамдық денсаулық сақтау жоғары мектебі» АҚ, Нұр-Сұлтан қ., денсаулық сақтау менеджменті`
    },
    specialization: {
      ru: `• Врач-оториноларинголог, хирург`,
      kz: `• Дәрігер-оториноларинголог, хирург`
    },
    certificates: {
      ru: `Повышение квалификации:
• 05.09–30.09.2020 гг. — ТОО «Национальный научный онкологический центр», эндовидеохирургические операции в хирургии
• 07.10–18.10.2024 гг. — АО «Медицинский университет Астана», функциональная эндоскопическая риносинусохирургия, включая детскую
• 21.08–28.08.2023 гг. — ТОО «Национальный научный центр развития образования «Санат», г. Кокшетау, актуальные вопросы финансового менеджмента в здравоохранении`,
      kz: `Біліктілікті арттыру:
• 05.09–30.09.2020 жж. — «Ұлттық ғылыми онкология орталығы» ЖШС, хирургиядағы эндобейнехирургиялық операциялар
• 07.10–18.10.2024 жж. — «Астана медицина университеті» АҚ, функционалдық эндоскопиялық риносинусохирургия, оның ішінде балалар риносинусохирургиясы
• 21.08–28.08.2023 жж. — «Санат» Ұлттық ғылыми білім беруді дамыту орталығы» ЖШС, Көкшетау қ., денсаулық сақтау саласындағы қаржылық менеджменттің өзекті мәселелері`
    },
    work: {
      ru: `• 08.2013–10.2025 гг. — ГКП на ПХВ «Жаркаинская районная больница», врач-хирург
• 01.2014–10.2025 гг. — ГКП на ПХВ «Жаркаинская районная больница», врач-оториноларинголог
• 06.2020–12.2020 гг. — ГКП на ПХВ «Жаркаинская районная больница», заместитель главного врача по лечебно-профилактической работе
• 2025 – по настоящее время — ГККП «Спортивный медицинский центр», г. Астана`,
      kz: `• 08.2013–10.2025 жж. — «Жарқайың аудандық ауруханасы» ШЖҚ КМК, дәрігер-хирург
• 01.2014–10.2025 жж. — «Жарқайың аудандық ауруханасы» ШЖҚ КМК, дәрігер-оториноларинголог
• 06.2020–12.2020 жж. — «Жарқайың аудандық ауруханасы» ШЖҚ КМК, емдеу-алдын алу жұмысы жөніндегі бас дәрігердің орынбасары
• 2025 – қазіргі уақытқа дейін — ГККП «Астана қаласының спорттық медицина орталығы»`
    }
  };
